import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from '../pages/Home';
import Todas_las_experiencia from '../pages/Todas_las_experiencia';
import ExperienciaDetalle from '../pages/ExperienciaDetalles';
import Contacto from '../pages/Contacto';
import Quiene_Somos from '../pages/Quiene_Somos';
import Receñas from '../pages/Receñas';


function Rutas() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/AllExperiencia" element={<Todas_las_experiencia />} />
        <Route path="/experiencia/:slug" element={<ExperienciaDetalle />} />
        <Route path="/Quienes_somos" element={<Quiene_Somos />} />
        <Route path="/reseñas" element={<Receñas />} />
        <Route path="/Contacto" element={<Contacto />} />


      </Routes>
    </Router>
  );
}

export default Rutas;
